<template lang="html">
  <div class="telehealth">
    <div class="content telehealth-content" ref="telehealthContent">
      <div class="telehealth-form main-content-cj h-100 mh-100">
        <b-container class="d-flex flex-column h-100 mh-100">
          <div class="box-container">
            <b-form-row>
              <b-col cols="12" md="7" class="d-flex justify-content-center align-items-center">

                <div v-if="telehealthAttendance != null && telehealthAttendance.start_datetime == null" class="text-center">
                  <div class="mb-3 patient-status-text"><i class="fas fa-exclamation-circle text-warning mr-2" v-if="telehealthAttendance.patient_entered"></i>O paciente {{telehealthAttendance.patient_entered ? 'está aguardando' : 'ainda não entrou'}}.</div>
                  <b-button variant="primary" @click="startTelehealthAttendance()" class="mb-3" :disabled="!canPerformAction"><i class="fas fa-video mr-2 "></i> Iniciar teleconsulta</b-button>
                </div>
                <div v-else-if="telehealthAttendance != null && telehealthAttendance.start_datetime != null && telehealthAttendance.end_datetime == null" class="agora-uikit-cj">
                  <div class="agora-call">
                    <div id="participants"></div>
                    <div style="background-color: rgb(0, 123, 255); width: 100%; height: 70px; z-index: 10; display: flex; flex-direction: row; justify-content: space-evenly; align-items: center;">
                      <b-button @click="toggleCamera()" variant="primary" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i :class="'far fa-video' + (videoEnabled ? '' : '-slash')"></i></b-button>
                      <b-button @click="toggleMicrophone()" variant="primary" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i :class="'far fa-microphone' + (audioMuted ? '-slash' : '')"></i></b-button>
                      <b-button @click="endTelehealthAttendance()" variant="danger" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i class="far fa-phone-slash"></i></b-button>
                    </div>
                  </div>
                </div>
                <div v-else-if="telehealthAttendance != null && telehealthAttendance.end_datetime != null" class="text-center">
                  <div>Teleconsulta finalizada.</div>
                </div>
              </b-col>
              <b-col cols="12" md="5" class="mh-100" id="attendance_menu">
                <div class="box-cj box-collapse" id="attendance_menu_box1">
                  <div class="header d-flex justify-content-between align-items-center py-2">
                    <div class="title">Marcador de atendimento</div>
                    <div class="time">{{ (timer == null)?'00:00:00':timer }}</div>
                  </div>
                  <div class="content pt-2">
                    <b-row>
                      <b-col cols="auto">
                        <label class="cj-label">Nome</label><br/>
                        <span class="preview name">{{ personForm.name }}<span v-if="personForm.internal_code != null && personForm.internal_code != ''"> ({{ personForm.internal_code }})</span>&nbsp;</span>
                      </b-col>
                      <b-col class="text-right">
                        <label class="cj-label">&nbsp;</label><br/>
                        <b-button variant="primary" size="sm" @click="$bvModal.show('access-info-modal')" class="mb-1"><i class="fas fa-sm fa-info-circle mr-2"></i> Acesso do paciente</b-button>
                      </b-col>

                      <div class="col-12 text-center mt-2">
                        <b-button v-if="timer == null" variant="primary" @click="startAttendanceAppointment(telehealthAppointment.id)" class="mb-1" :disabled="!canPerformAction"><i class="far fa-sm fa-play-circle mr-2 "></i> Iniciar atendimento</b-button>
                        <b-button v-else variant="warning" @click="endAttendance()" class="mb-1" :disabled="!canPerformAction"><i class="far fa-sm fa-stop-circle mr-2"></i> Encerrar atendimento</b-button>
                      </div>
                    </b-row>
                  </div>
                </div>
                <div class="box-cj mb-0" id="attendance_menu_box2">
                  <div class="header appointment-history-header">
                    <div class="w-100 d-flex justify-content-between">
                      <div class="d-flex flex-column flex-xl-row">
                        <b-tabs>
                          <b-tab title="Prontuário / Receituário" title-link-class="show-appointments" :active="activeTab === 'attendance-form'" @click="showTab('attendance-form')"></b-tab>
                          <b-tab title="Guias" title-link-class="show-appointments" :active="activeTab === 'attendance-guides'" @click="showTab('attendance-guides')"></b-tab>
                          <b-tab title="Histórico" title-link-class="show-appointments" :active="activeTab === 'past-appointments'" @click="showTab('past-appointments')"></b-tab>
                          <b-tab title="Agendamentos" title-link-class="show-appointments" :active="activeTab === 'future-appointments'" @click="showTab('future-appointments')"></b-tab>
                          <b-tab title="Lembretes" title-link-class="show-appointments" :active="activeTab === 'reminders'" @click="showTab('reminders')"></b-tab>
                        </b-tabs>
                      </div>
                      <div>
                        <date-range-picker
                          class="only-icon"
                          ref="picker"
                          :localeData="dateRangePickerPtBrLocale"
                          :timePicker="false"
                          :timePicker24Hour="false"
                          :showDropdowns="true"
                          :ranges="false"
                          :showWeekNumbers="false"
                          :opens="'left'"
                          v-model="appointmentsFilter.dateTime">
                          <div slot="input" slot-scope="picker" class="text-center" style="margin:0; padding:0; border:0">
                            <span class="print-ico"><i class="far fa-search"></i></span>
                          </div>
                        </date-range-picker>
                        <span class="print-ico" @click="print" v-if="attendances.length > 0"><i class="far fa-print"></i></span>
                      </div>
                    </div>
                    <div class="w-100 d-flex justify-content-between" v-if="appointmentsFilter.dateTime.startDate != null">
                      <div>
                        <small class="cj-label">{{ moment(appointmentsFilter.dateTime.startDate).format('DD/MM/YYYY') }} - {{ moment(appointmentsFilter.dateTime.endDate).format('DD/MM/YYYY') }}</small>
                      </div>
                      <div>
                        <small class="print-ico" @click="cleanAppointmentsFilter">Limpar filtro</small>
                      </div>
                    </div>
                  </div>
                  <div class="content tab-content">
                    <perfect-scrollbar :style="'height:' + scrollbarHeight + 'px'">
                      <template v-if="timer != null && activeTab === 'attendance-form'">
                        <validation-observer ref="attendanceForms" v-slot="{ invalid }">
                          <div class="box-cj" v-for="attendanceForm in attendanceForms" :key="attendanceForm.id">
                            <div class="header">
                              <div class="d-flex justify-content-between align-items-center">
                                <p class="title">Prontuário</p>
                                <div>
                                  <label class="cj-label pointer" @click="removeAttendanceForm(attendanceForm.id, attendanceForm.form != null ? attendanceForm.form.value : null)">Deletar prontuário <i class="far fa-trash ml-2"></i></label>
                                </div>
                              </div>
                            </div>
                            <div class="content">
                              <b-row class="mb-2">
                                <b-col lg="8">
                                  <label class="cj-label">Modelo de prontuário</label>
                                  <multiselect v-model="attendanceForm.form" :options="getAvailableForms(attendanceForm.form)" track-by="name" label="name" :showLabels="false" :allow-empty="false" :searchable="true" placeholder="Escolha um para começar"></multiselect>
                                </b-col>
                              </b-row>
                              <b-row v-if="attendanceForm.form != null">
                                <b-col v-for="field in attendanceForm.form.fields" :key="field.id" :lg="field.cols" :order="field.order" class="mb-2">
                                  <FormField :field="field"></FormField>
                                </b-col>
                              </b-row>
                            </div>
                          </div>
                        </validation-observer>

                        <div class="box-cj" v-for="prescription in attendancePrescriptions" :key="prescription.id">
                          <div class="header">
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="title">Receituário</p>
                              <div>
                                <label class="cj-label pointer" @click="removePrescription(prescription)">Deletar receituário <i class="far fa-trash ml-2"></i></label>
                              </div>
                            </div>
                          </div>
                          <div class="content">
                            <b-row>
                              <b-col cols="12" class="mb-1" v-if="prescription.value.AtestadoPDFUrl != null">
                                <a :href="prescription.value.AtestadoPDFUrl" target="_blank"><i class="far fa-notes-medical"></i> Atestado</a>
                              </b-col>
                              <b-col cols="12" class="mb-1" v-if="prescription.value.PDFUrl != null">
                                <a :href="prescription.value.PDFUrl" target="_blank"><i class="far fa-pills"></i> Receita(s)</a>
                              </b-col>
                              <b-col cols="12" class="mb-1" v-if="prescription.value.ExamePDFUrl  != null">
                                <a :href="prescription.value.ExamePDFUrl " target="_blank"><i class="far fa-stethoscope"></i> Pedido(s) de exame</a>
                              </b-col>
                            </b-row>
                          </div>
                        </div>
                      </template>
                      <template v-if="activeTab === 'attendance-guides'">
                        <div class="box-cj">
                          <div class="header">
                            <p class="title">Guias de Atendimento</p>
                          </div>
                          <div class="content">
                            <table class="table table-responsive w-100 d-block d-md-table table-centered table-striped">
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>Atendimento</th>
                                <th>Convênio</th>
                                <th>Profissional</th>
                                <th>Status</th>
                                <th></th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="attendanceGuide in attendanceGuides" :key="attendanceGuide.id">
                                <td>{{ attendanceGuide.internal_id }}</td>
                                <td>{{ moment(attendanceGuide.appointment.start_datetime).format('DD/MM/YY HH:mm') }}</td>
                                <td>{{ attendanceGuide.appointment.health_plan.name }}</td>
                                <td>{{ shorten(attendanceGuide.appointment.professional.name, 18) }}</td>
                                <td>{{ attendanceGuide.pending?'Aberta':'Fechada' }}</td>
                                <td>
                                  <b-button size="sm" variant="primary" @click="showAttendanceGuideModal(attendanceGuide)" v-if="canEdit"><i :class="'far ' + (attendanceGuide.pending ? 'fa-pencil-alt' : 'fa-eye')"></i></b-button>
                                </td>
                              </tr>
                              <tr v-if="attendanceGuides.length == 0">
                                <td colspan="5" class="text-center">
                                  Este paciente não possui nenhuma guia de atendimento.
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="activeTab === 'past-appointments' || activeTab === 'future-appointments'">
                        <ul class="appointments-list" v-if="getPersonTimeline().length > 0">
                          <li v-for="(date, index) in getPersonTimeline()" :class="moment(date).isSame(moment(), 'day') ? 'current-day' : ''" :key="index">
                            <span class="timeline"></span>
                            <p class="date">{{ moment(date).format('DD/MM/YYYY (dddd)') }}</p>

                            <template v-if="getInfoByDate(date).appointments.length > 0">
                              <template v-for="appointment in getInfoByDate(date).appointments">
                                <p :key="appointment.id" class="info ml-3">
                                  <small class="d-flex flex-column" :class="{ 'ufoGreen': (appointment.status == 'SHOWEDUP' || appointment.status == 'ATTENDED'), 'dullRed': (appointment.status == 'MISSED' || appointment.status == 'CANCELED') }">
                                    <div class="row">
                                      <span class="col-6 text-nowrap overflow-hidden" :title="moment(appointment.start_datetime).format('HH:mm')"><i class="far" :class="{ 'fa-calendar': (appointment.status != 'SHOWEDUP' && appointment.status != 'ATTENDED' && appointment.status != 'MISSED' && appointment.status != 'CANCELED'), 'fa-calendar-check ufoGreen': (appointment.status == 'SHOWEDUP' || appointment.status == 'ATTENDED'), 'fa-calendar-times dullRed': (appointment.status == 'MISSED' || appointment.status == 'CANCELED') }"></i> {{ moment(appointment.start_datetime).format('HH:mm') }}</span>
                                      <span class="col-6 text-nowrap overflow-hidden" :title="appointment.professional.name"><i class="far fa-user-tie"></i> {{ appointment.professional.name }}</span>
                                      <span class="col-6 text-nowrap overflow-hidden" :title="appointment.health_plan.name"><i class="far fa-file-invoice-dollar"></i> {{ appointment.health_plan.name }}</span>
                                      <span class="col-6 text-nowrap overflow-hidden" :title="helpers.getStatusName(appointment.status)"><i class="far fa-info-circle"></i> {{ helpers.getStatusName(appointment.status) }}</span>
                                    </div>
                                  </small>
                                </p>
                              </template>
                            </template>

                            <template v-if="getInfoByDate(date).attendances.length > 0 && attendancesWithFormsOrPrescriptions(getInfoByDate(date).attendances)">
                              <template v-for="attendance in getInfoByDate(date).attendances">
                                <p :key="attendance.id" v-if="attendance.forms.length > 0 || attendance.prescriptions.length > 0" class="info ml-3">
                                  <small class="d-flex flex-column">
                                    <div class="row">
                                      <span class="col-6 text-nowrap overflow-hidden" :title="moment(attendance.start_datetime).format('HH:mm')"><i class="far fa-calendar"></i> {{ moment(attendance.start_datetime).format('HH:mm') }}</span>
                                      <span class="col-6 text-nowrap overflow-hidden" :title="attendance.professional.name"><i class="far fa-user-tie"></i> {{ attendance.professional.name }}</span>

                                      <template v-for="form in attendance.forms">
                                        <span class="col-12 attendance-item" :key="attendance.id+form.id" @click="showForm(form, attendance)"><i class="far fa-notes-medical"></i> {{ form.name }}
                                          <i v-if="form.notes.length > 0 && (((user.person.client.enable_coordinator_profile || user.person.client.enable_professional_notes) && user.person.id == attendance.professional_id))" class="far fa-comment-alt-lines float-right mt-1"></i>
                                        </span>
                                      </template>
                                      <template v-for="prescription in attendance.prescriptions">
                                        <a :key="prescription.id+'Atestado'" class="col-12 attendance-item mb-1" v-if="prescription.value.AtestadoPDFUrl != null" :href="prescription.value.AtestadoPDFUrl" target="_blank"><i class="far fa-notes-medical"></i> Atestado</a>
                                        <a :key="prescription.id+'Receita'" class="col-12 attendance-item mb-1" v-if="prescription.value.PDFUrl != null" :href="prescription.value.PDFUrl" target="_blank"><i class="far fa-pills"></i> Receita(s)</a>
                                        <a :key="prescription.id+'Exame'" class="col-12 attendance-item mb-1" v-if="prescription.value.ExamePDFUrl != null" :href="prescription.value.ExamePDFUrl" target="_blank"><i class="far fa-stethoscope"></i> Pedido(s) de exame</a>
                                      </template>
                                    </div>
                                  </small>
                                </p>
                              </template>
                            </template>
                          </li>
                        </ul>
                        <p class="text-center" v-else-if="getPersonTimeline().length > 0 && appointmentsFilter.dateTime.startDate == null">Este paciente não possui nenhum atendimento.</p>
                        <p class="text-center" v-else>Este paciente não possui nenhum atendimento entre as datas informadas.</p>
                      </template>
                      <template v-else-if="activeTab === 'reminders'">
                        <b-button variant="primary" block @click="showReminderModal()" class="mb-3"><i class="far fa-sm fa-plus-circle mr-2 "></i>  Adicionar lembrete</b-button>
                        <ul class="appointments-list" v-if="reminders.length > 0">
                          <li v-for="(date, index) in getPersonRemindersTimeline()" :class="moment(date).isSame(moment(), 'day') ? 'current-day' : ''" :key="'remindersTimeline-'+index">
                            <span class="timeline"></span>
                            <p class="date">{{ moment(date).format('DD/MM/YYYY (dddd)') }}</p>

                            <template v-if="getRemindersByDate(date).length > 0">
                              <template v-for="reminder in getRemindersByDate(date)">
                                <p :key="'reminders-'+reminder.id" class="info ml-3">
                                  <small class="d-flex flex-column">
                                    <div class="row">
                                      <span @click="editReminder(reminder)" class="col-12 reminder-item mb-1" ><i class="far fa-tag"></i> {{ reminderTypes.find(reminderType => reminderType.value == reminder.reminder_type_id).name }}</span>
                                      <span @click="editReminder(reminder)" v-if="reminder.description" class="col-12 reminder-item mb-1" >{{ reminder.description }}</span>
                                    </div>
                                  </small>
                                </p>
                              </template>
                            </template>
                          </li>
                        </ul>
                        <p class="text-center" v-else>Este paciente não possui nenhum lembrete.</p>
                      </template>
                    </perfect-scrollbar>
                    <template v-if="timer != null && activeTab === 'attendance-form'">
                      <b-button block class="btn-add-new mt-3" v-if="getAvailableForms(null).length > 0 && showAddNewButton()" @click="addNewFormToAttendance"><i class="far fa-plus-circle mr-2"></i> Adicionar prontuário</b-button>
                      <b-button block class="btn-add-new-green mt-3" v-if="showAddNewPrescriptionButton()" @click="addNewPrescriptionToAttendance"><i class="far fa-plus-circle mr-2"></i> Adicionar receituário</b-button>
                    </template>
                    <template v-if="activeTab === 'attendance-guides'">
                      <b-button variant="primary" block v-if="telehealthAppointment != null" @click="showAttendanceGuideModal(null)" class="mt-3">Gerar guia de atendimento</b-button>
                    </template>
                    <template v-else-if="activeTab === 'past-appointments' || activeTab === 'future-appointments'">
                      <b-button variant="primary" block v-if="getPersonTimeline().length > 0 && hasMoreTimeline" @click="loadMoreAppointments()" class="mt-3"><i class="far fa-sm fa-redo mr-2 "></i>  Carregar mais atendimentos</b-button>
                      <b-button variant="primary" block v-if="showPastAppointments && getPersonTimeline().length > 0" @click="showFullHistory()" class="mt-3"><i class="far fa-sm fa-list mr-2 "></i>  Exibir histórico completo</b-button>
                    </template>
                  </div>
                </div>
              </b-col>

              <b-modal id="access-info-modal" size="lg">
                <template slot="modal-header">
                  Dados de acesso do paciente
                </template>
                <template slot="default" v-if="telehealthAttendance != null">
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="cj-form-field">
                        <label class="cj-label">Link do paciente</label>
                        <div>{{aolUrl + 'teleconsulta/' + telehealthAttendance.id}}</div>
                      </div>
                    </b-col>
                    <b-col cols="12" class="mb-2">
                      <div class="cj-form-field">
                        <label class="cj-label">Código de acesso</label>
                        <div>{{telehealthAttendance.code}}</div>
                      </div>
                    </b-col>
                    <b-col cols="12" class="text-center">
                      <b-button variant="primary" @click="sendTelehealthWhatsapp">Enviar Whatsapp <i class="fab fa-whatsapp"></i></b-button>
                    </b-col>
                  </b-row>
                </template>
                <template slot="modal-footer">
                  <b-button size="sm" @click="$bvModal.hide('access-info-modal')">Fechar</b-button>
                </template>
              </b-modal>

              <b-modal id="form-modal" class="form-modal" :size="formSelectedShowNotes ? 'xl' : 'lg'" :modalClass="'form-modal'" @hidden="resetFormModal">
                <template slot="modal-header" v-if="formSelected != null">
                  <div class="w-100 d-flex justify-content-between">
                    <div>
                      {{ formSelected.name }}
                    </div>
                    <div>
                      <span class="print-ico" @click="print"><i class="far fa-print"></i></span>
                      <span v-if="((user.person.client.enable_coordinator_profile || user.person.client.enable_professional_notes) && user.person.id == formSelectedProfessionalId)" class="notes-ico ml-3" @click="formSelectedShowNotes = !formSelectedShowNotes"><i class="far fa-comment-alt-lines"></i></span>
                    </div>
                  </div>
                </template>
                <template slot="default" v-if="formSelected != null">
                  <b-row v-if="formSelected.fields.length > 0">
                    <b-col>
                      <b-row>
                        <b-col v-for="field in formSelected.fields" :key="field.id" :md="field.cols" :order="field.order" class="mb-2">
                          <FormField :field="field" :readonly="true" :preview="true"></FormField>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col v-if="formSelectedShowNotes" cols="12" :md="4" class="notes-container">
                      <template v-for="note in formSelected.notes">
                        <div class="cj-form-field">
                          <label class="cj-label">{{moment(note.created_at).format('DD/MM/YYYY HH:mm')}} - {{note.person_name}}:</label>
                          <div>
                            <nl2br tag="p" :text="note.value" class-name="note-value mb-1" />
                          </div>
                        </div>
                      </template>
                      <template v-if="(user.person.client.enable_professional_notes && user.person.id == formSelectedProfessionalId)">
                        <validation-observer ref="noteForm" v-slot="{ invalid }">
                          <div :class="'cj-form-field' + (formSelected.notes.length > 0 ? ' mt-3' : '')">
                            <label class="cj-label">Anotação</label>
                            <div>
                              <validation-provider name="anotação" :rules="{ required: true }" v-slot="{ errors }">
                                <b-form-textarea v-model="formSelectedNote" rows="3" :class="{ 'error': errors.length > 0 }"></b-form-textarea>
                                <span class="cj-error">{{ errors[0] }}</span>
                              </validation-provider>
                            </div>
                          </div>
                        </validation-observer>
                        <div class="text-right mt-2">
                          <b-button size="sm" variant="primary" @click="saveFormNote">Enviar</b-button>
                        </div>
                      </template>
                    </b-col>
                  </b-row>
                </template>
                <template slot="modal-footer">
                  <b-button size="sm" @click="$bvModal.hide('form-modal')">Fechar</b-button>
                </template>
              </b-modal>

              <b-modal id="history-modal" class="history-modal" :modalClass="'history-modal'" size="lg">
                <template slot="modal-header">
                  <div class="w-100 d-flex justify-content-between">
                    <div>
                      Histórico do paciente {{ personForm.name }}
                    </div>
                    <div>
                      <span class="print-ico" @click="print"><i class="far fa-print"></i></span>
                    </div>
                  </div>
                </template>
                <template slot="default">
                  <template v-for="(attendance, index) in attendances">
                    <template v-for="form in attendance.forms">
                      <div :key="form.id" class="mt-3 mb-3">
                        <div class="text-center mb-5">
                          <h3 class="text-center">{{ form.name }} de {{ personForm.name }}</h3>
                          <h4 class="text-center">Atendido em {{ moment(attendance.start_datetime).format('DD/MM/YYYY HH:mm:ss') }} por {{ attendance.professional.name  }}</h4>
                          <h5 class="text-center" v-if="index == 0">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
                        </div>
                        <div class="mt-3 fields">
                          <div v-for="field in getFieldsInOrder(form.fields)" :key="field.id" class="field" :class="'field-'+field.cols">
                            <FormField :field="field" :readonly="true" :printable="true"></FormField>
                          </div>
                        </div>
                        <hr>
                      </div>
                    </template>
                  </template>
                </template>
                <template slot="modal-footer">
                  <b-button size="sm" @click="$bvModal.hide('history-modal')">Fechar</b-button>
                </template>
              </b-modal>

              <b-modal id="attendance-guide-modal" class="attendance-guide-modal" size="xl" ignore-enforce-focus-selector=".swal2-input" :modalClass="'attendance-guide-modal'" @hidden="resetAttendanceGuideModal">
                <template slot="modal-header">
                  <div class="w-100 d-flex justify-content-between">
                    <div v-if="attendanceGuideForm.id != null">
                      Guia de Atendimento #{{ attendanceGuideForm.internal_id }}
                    </div>
                    <div v-else>
                        Nova Guia de Atendimento para {{ attendanceGuideForm.name }}
                    </div>
                    <div v-if="attendanceGuideForm.id != null">
                      <router-link tag="a" target="_blank" class="print-ico" :to="'/guia-de-atendimento/' + attendanceGuideForm.id + '/imprimir'"><i class="far fa-print"></i></router-link>
                    </div>
                  </div>
                </template>
                <template slot="default">
                  <b-col>
                    <validation-observer ref="attendanceGuideForm" v-slot="{ invalid }">
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Convênio</label>
                          <validation-provider name="convênio" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="attendanceGuideForm.health_plan" :disabled="true" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Data do atendimento</label>
                          <b-form-input type="text" v-model="attendanceGuideForm.start_datetime" :disabled="true" autocomplete="off"></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col>
                          <label class="cj-label">Profissional</label>
                          <b-form-input type="text" v-model="attendanceGuideForm.professional.name" :disabled="true" autocomplete="off"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Forma de faturamento</label>
                          <validation-provider name="forma de faturamento" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="attendanceGuideForm.bill_type" :options="billTypeOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="false" :showLabels="false" :searchable="true" :disabled="(attendanceGuideForm.invoices.length > 0)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </validation-observer>
                    <hr>
                    <validation-observer v-if="attendanceGuideForm.pending && user != null && (attendanceGuideForm.invoices.length === 0 || (attendanceGuideForm.bill_type != null && attendanceGuideForm.bill_type.value === 'accomplished_procedures'))" ref="attendanceGuideItemForm" v-slot="{ invalid }">
                      <b-col class="p-3 mb-3 background-color-whisper">
                        <b-row v-if="attendanceGuideForm.is_dentist" class="mb-2">
                          <b-col>
                            <label class="cj-label">Dente/Área</label>
                            <validation-provider name="dente/área" :rules="{ required: true }" v-slot="{ errors }">
                              <multiselect v-model="attendanceGuideForm.item.tooth" :options="teeth" :showLabels="false" :searchable="true" placeholder="Dente/Área" :class="{ 'error': errors.length > 0 }"></multiselect>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label class="cj-label">Face(s)</label>
    <!--                        <validation-provider name="face" :rules="{ required: (typeof attendanceGuideForm.item.tooth === 'number') || (attendanceGuideForm.item.tooth != null && !isNaN(attendanceGuideForm.item.tooth)) }" v-slot="{ errors }">-->
                            <validation-provider name="face(s)" :rules="{ required: false }" v-slot="{ errors }">
                              <multiselect v-model="attendanceGuideForm.item.faces" :options="faces" :showLabels="false" :searchable="true" :multiple="true" placeholder="Face(s)" :class="{ 'error': errors.length > 0 }"></multiselect>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mb-3">
                          <b-col cols="12" md="6">
                            <label class="cj-label">Procedimento</label>
                            <validation-provider name="procedimento" :rules="{ required: true }" v-slot="{ errors }">
                              <multiselect ref="multiselectProcedure" :preserveSearch="true" v-model="attendanceGuideForm.item.procedure" :options="attendanceGuideProcedures" track-by="name" label="name" :loading="isLoadingAttendanceGuideProcedures" :internal-search="false" :options-limit="20" :limit="5" :max-height="200" @search-change="findAttendanceGuideProcedures" :showLabels="false" placeholder="Selecione um procedimento" :class="{ 'error': errors.length > 0 }">
                                <template slot="noOptions">
                                  <div>
                                    Digite para pesquisar procedimentos...
                                  </div>
                                </template>
                                <template slot="noResult" v-if="!isLoadingAttendanceGuideProcedures">
                                  <div>
                                    Nenhum procedimento encontrado...
                                  </div>
                                </template>
                              </multiselect>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label class="cj-label">Quantidade</label>
                            <validation-provider name="quantidade" :rules="{ required: true }" v-slot="{ errors }">
                              <b-form-input v-model="attendanceGuideForm.item.amount" type="number" min="1" step="1" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label class="cj-label">Valor</label>
                            <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                              <money v-model="attendanceGuideForm.item.value" class="form-control" :class="{ 'error': errors.length > 0 }"></money>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mb-2 justify-content-end">
                          <b-col cols="auto">
                            <b-button variant="success" @click="addItemToAttendanceGuide">Adicionar</b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </validation-observer>

                    <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                      <thead>
                      <tr>
                        <th v-if="attendanceGuideForm.is_dentist">Dente/Área</th>
                        <th v-if="attendanceGuideForm.is_dentist">Face(s)</th>
                        <th>Procedimento</th>
                        <th>Quantidade</th>
                        <th>Valor</th>
                        <th class="text-center">Realizado?</th>
                        <th class="text-center">Faturado?</th>
                        <th class="text-center"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) of attendanceGuideForm.items" :key="index">
                        <td v-if="attendanceGuideForm.is_dentist">{{ item.tooth != null ? item.tooth : '-' }}</td>
                        <td v-if="attendanceGuideForm.is_dentist">{{ item.faces != null ? item.faces : '-' }}</td>
                        <td>{{ item.procedure.name }}</td>
                        <td>{{ item.amount }}</td>
                        <td>R$ {{ formatPrice(item.value) }}</td>
                        <td class="text-center">
                          <div v-if="!attendanceGuideForm.pending || (attendanceGuideForm.bill_type != null && attendanceGuideForm.bill_type.value === 'accomplished_procedures' && item.attendance_guide_invoice_id != null)" class="pretty p-switch p-fill">
                            {{item.accomplished ? 'Sim' : 'Não'}}
                          </div>
                          <div v-else class="pretty p-switch p-fill">
                            <input type="checkbox" v-model="item.accomplished" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          {{item.attendance_guide_invoice_id != null ? 'Sim' : 'Não'}}
                        </td>
                        <td class="text-center">
                          <b-button v-if="item.attendance_guide_invoice_id == null" size="sm" variant="danger" @click="removeItemFromAttendanceGuide(index)"><i class="far fa-trash-alt"></i></b-button>
                        </td>
                      </tr>
                      <tr v-if="attendanceGuideForm.items.length == 0">
                        <td :colspan="(attendanceGuideForm.is_dentist ? 8 : 6)" class="text-center">
                          Nenhum item adicionado à guia.
                        </td>
                      </tr>
                      </tbody>
                      <tfoot v-if="attendanceGuideForm.items.length > 0">
                      <tr>
                        <td v-if="attendanceGuideForm.is_dentist"></td>
                        <td v-if="attendanceGuideForm.is_dentist"></td>
                        <td></td>
                        <td class="text-right">Total:</td>
                        <td>R$ {{ formatPrice(attendanceGuideForm.items.reduce((total, item) => total + item.value, 0)) }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>

                    <div v-if="attendanceGuideForm.invoices.length > 0">
                      <label class="text1">Faturas</label>
                    </div>
                    <table v-if="attendanceGuideForm.invoices.length > 0" class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                      <thead>
                      <tr>
                        <th>Lançamento</th>
                        <th>Vencimento</th>
                        <th>Valor</th>
                        <th>Status</th>
                        <th>Baixa</th>
                        <th class="text-center"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <template v-for="(invoice, index) in attendanceGuideForm.invoices">
                          <tr v-for="(transaction, transactionIndex) of invoice.transactions" :key="index + '-' + transactionIndex">
                            <td>{{ moment(transaction.registration_date).format('DD/MM/YYYY') }}</td>
                            <td>{{ transaction.charge_date != null ? moment(transaction.charge_date).format('DD/MM/YYYY') : '-' }}</td>
                            <td>R$ {{ formatPrice(invoice.transaction.value) }}</td>
                            <td>{{ !transaction.discharged?'Não ':'' }} Recebido</td>
                            <td>{{ transaction.discharge_date != null ? moment(transaction.discharge_date).format('DD/MM/YYYY') : '' }}</td>
                            <td class="text-center">
                              <router-link v-if="transaction != null" tag="button" class="btn btn-primary btn-sm" :to="'/financeiro/contas-a-receber/'+transaction.id"><i class="far fa-eye mr-1"></i> Ver fatura</router-link>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <tfoot v-if="attendanceGuideForm.items.length > 0">
                      <tr>
                        <td></td>
                        <td class="text-right">Total:</td>
                        <td>R$ {{ formatPrice(attendanceGuideForm.invoices.reduce((total, invoice) => total + invoice.transactions.reduce((totalTransaction, transaction) => totalTransaction + transaction.value, 0), 0)) }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="text-right">Comissão:</td>
                        <td>R$ {{ formatPrice(attendanceGuideForm.professional.commission_percentage * attendanceGuideForm.invoices.reduce((total, invoice) => total + invoice.transactions.reduce((totalTransaction, transaction) => totalTransaction + transaction.value, 0), 0) / 100.0) }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>
                  </b-col>
                </template>
                <template slot="modal-footer">
                  <b-button size="sm" @click="$bvModal.hide('attendance-guide-modal')">Fechar</b-button>
                  <b-button v-if="attendanceGuideForm.pending" size="sm" variant="success" @click="saveAttendanceGuide(false)">Salvar</b-button>
                  <b-button v-if="helpers.planHasPermission('financial') && attendanceGuideForm.pending && attendanceGuideForm.bill_type != null && (attendanceGuideForm.bill_type.value === 'accomplished_procedures' || attendanceGuideForm.invoices.length === 0)" size="sm" variant="primary" @click="billAttendanceGuide()">Faturar</b-button>
                </template>
              </b-modal>

              <b-modal id="prescription-form-modal" size="xl" hide-header hide-footer no-close-on-backdrop>
                <template slot="default">
                  <iframe v-if="currentPrescription != null" :src="currentPrescription.embed_url"></iframe>
                </template>
              </b-modal>

              <b-modal id="reminder-modal" class="reminder-modal" size="lg" :modalClass="'reminder-modal'" @hidden="resetReminderModal">
                <template slot="modal-header">
                  <div class="w-100 d-flex justify-content-between">
                    <div>
                      Lembrete para {{ personForm.name }}
                    </div>
                  </div>
                </template>
                <template slot="default">
                  <b-col>
                    <validation-observer ref="reminderForm" v-slot="{ invalid }">
                      <b-row class="mb-3">
                        <b-col>
                          <label class="cj-label">Data do lembrete</label>
                          <validation-provider name="data do lembrete" :rules="{ required: true }" v-slot="{ errors }">
                            <date-picker name="date" v-model="reminderForm.date" v-mask="'##/##/####'" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <validation-provider name="tipo" :rules="{ required: true }" v-slot="{ errors }">
                            <label class="cj-label">Tipo</label>
                            <multiselect v-model="reminderForm.type" :options="reminderTypes" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col>
                          <label class="cj-label">Descrição</label>
                          <validation-provider name="descrição" v-slot="{ errors }">
                            <b-form-input type="text" v-model="reminderForm.description" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" maxlength="200" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </validation-observer>
                  </b-col>
                </template>
                <template slot="modal-footer">
                  <b-button size="sm" @click="$bvModal.hide('reminder-modal')">Fechar</b-button>

                  <b-button-group size="sm">
                    <b-button variant="danger" v-if="reminderForm.id != null" @click="deleteReminder(reminderForm)">Remover</b-button>
                    <b-button size="sm" variant="success" @click="saveReminder">Salvar</b-button>
                  </b-button-group>
                </template>
              </b-modal>

            </b-form-row>
          </div>
        </b-container>

        <div class="printable" v-if="user != null && formSelected != null">
          <div class="print-header">
            <img :src="logo" width="100" :alt="formSelected.unit.display_name">
            <div class="print-client-info">
              <h1 class="mt-0 mb-1">{{ formSelected.unit.display_name }}</h1>
              <div>{{ formSelected.unit.display_document }}</div>
              <div v-if="formSelected.unit.display_telephone != null && formSelected.unit.display_telephone != ''"><i class="fal fa-phone fa-flip-horizontal mr-1"></i> {{ formSelected.unit.display_telephone }}</div>
            </div>
            <div class="print-client-info text-right">
              <div v-if="formSelected.unit.display_cellphone != null && formSelected.unit.display_cellphone != ''"><i class="fab fa-whatsapp mr-1"></i> {{ formSelected.unit.display_cellphone }}</div>
              <div><i class="fal fa-map-marker-alt mr-1"></i> {{ buildFormSelectedAddress(formSelected.unit) }}</div>
            </div>
          </div>
          <div class="text-center mb-5">
            <h3 class="text-center">{{ formSelected.name }} de {{ personForm.name }}</h3>
            <h4 class="text-center">Gerado em {{ moment(formSelected.created_at).format('DD/MM/YYYY HH:mm:ss') }} por {{ formSelected.professional }}</h4>
            <h5 class="text-center">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
          </div>
          <div class="mt-3 fields">
            <div v-for="field in getFieldsInOrder(formSelected.fields)" :key="field.id" class="field" :class="'field-'+field.cols">
              <FormField :field="field" :readonly="true" :printable="true"></FormField>
            </div>
          </div>
        </div>

        <div class="printable" v-if="user != null && formSelected == null">
          <div class="print-header">
            <img :src="logo" width="100" :alt="user.person.client.default_unit.display_name">
            <div class="print-client-info">
              <h1 class="mt-0 mb-1">{{ user.person.client.default_unit.display_name }}</h1>
              <div>{{ user.person.client.default_unit.display_document }}</div>
              <div v-if="user.person.client.default_unit.display_telephone != null && user.person.client.default_unit.display_telephone != ''"><i class="fal fa-phone fa-flip-horizontal mr-1"></i> {{ user.person.client.default_unit.display_telephone }}</div>
            </div>
            <div class="print-client-info text-right">
              <div v-if="user.person.client.default_unit.display_cellphone != null && user.person.client.default_unit.display_cellphone != ''"><i class="fab fa-whatsapp mr-1"></i> {{ user.person.client.default_unit.display_cellphone }}</div>
              <div><i class="fal fa-map-marker-alt mr-1"></i> {{ buildFormSelectedAddress(user.person.client.default_unit) }}</div>
            </div>
          </div>
          <template v-for="(attendance, index) in attendances">
            <template v-for="form in attendance.forms">
              <div :key="'printableAttendanceForms-'+form.id+index" class="mt-3 mb-3">
                <div class="text-center mb-5">
                  <img src="@/assets/images/consulta-ja-logo.png" height="50" class="mb-3" alt="" v-if="index == 0">
                  <h3 class="text-center">{{ form.name }} de {{ personForm.name }}</h3>
                  <h4 class="text-center">Atendido em {{ moment(attendance.start_datetime).format('DD/MM/YYYY HH:mm:ss') }} por {{ attendance.professional.name  }}</h4>
                  <h5 class="text-center" v-if="index == 0">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
                </div>
                <div class="mt-3 fields">
                  <div v-for="field in getFieldsInOrder(form.fields)" :key="field.id" class="field" :class="'field-'+field.cols">
                    <FormField :field="field" :readonly="true" :printable="true"></FormField>
                  </div>
                </div>
                <hr>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {compressToUTF16, decompressFromUTF16} from "lz-string";
  import AgoraRTC from "agora-rtc-sdk-ng";

  export default {
    data() {
      return {
        leavingPage: false,

        isMobile: false,
        aolUrl: process.env.VUE_APP_AOL_URL,
        agoraId: process.env.VUE_APP_AGORA_ID,
        agoraToken: '',
        agoraClient: null,
        localAudioTrack: null,
        audioMuted: false,
        localVideoTrack: null,
        loadedChannel: false,
        leftChannel: false,
        videoEnabled: true,
        spectators: [],

        telehealthCheckInterval: null,

        user: null,
        logo: '',

        termSingular: '',
        url: '',
        module: '',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        canManageSubscription: false,

        personForm: {
          id: null,
          type: 'PATIENT',
          name: '',
          internal_code: '',
          document: '',
          birthday: '',
          gender: '',
          email: '',
          telephone: '',
          cellphone: '',
          health_plan: '',
          card_number: '',
          notes: '',
          address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          },
          health_plans: []
        },

        appointments: [],
        attendances: [],

        attendanceGuides: [],
        reminders: [],
        units: [],

        reminderTypes: [],

        reminderForm: {
          id: null,
          type: null,
          description: '',
          date: '',
        },

        billTypeOptions: [
          { value: 'accomplished_procedures', name: 'Por procedimento realizado' },
          { value: 'full_guide', name: 'Guia completa' }
        ],

        scrollbarHeight: 490,

        activeTab: 'attendance-form',
        showPastAppointments: true,
        futureAppointments: [],
        telehealthAppointment: null,
        telehealthAttendance: null,
        attendanceGuideForm: {
          id: null,
          appointment_id: null,
          health_plan_id: null,
          start_datetime: '',
          internal_id: '',
          name: '',
          professional: {
            name: '',
            commission_percentage: 0,
            specialities: [],
          },
          is_dentist: false,
          health_plan: '',
          bill_type: '',
          authorization_code: '',
          pending: true,
          items: [],
          invoices: [],
          item: {
            id: null,
            attendance_guide_invoice_id: null,
            tooth: null,
            faces: null,
            procedure: null,
            amount: 1,
            value: 0,
            accomplished: false
          }
        },
        attendanceGuideProcedures: [],
        isLoadingAttendanceGuideProcedures: false,
        findAttendanceGuideProceduresTimer: null,

        genderOptions: [
          { value: 'U', name: 'Não informado' },
          { value: 'M', name: 'Masculino' },
          { value: 'F', name: 'Feminino' }
        ],

        healthPlans: [],

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },

        attendanceInProgress: null,
        attendanceStartDatetime: null,
        interval: null,
        timer: null,

        forms: [],
        attendanceForms: [],
        attendancePrescriptions: [],
        currentPrescription: null,

        formSelected: null,
        formSelectedShowNotes: false,
        formSelectedAttendanceId: null,
        formSelectedProfessionalId: null,
        formSelectedNote: '',

        procedures: [],
        isLoadingProcedures: false,

        teeth: ['Boca toda', 'Arcada Superior', 'Arcada Inferior', 11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28, 31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 51, 52, 53, 54, 55, 61, 62, 63, 64, 65, 71, 72, 73, 74, 75, 81, 82, 83, 84, 85],
        faces: ['Vestibular', 'Palatina', 'Lingual', 'Mesial', 'Distal', 'Oclusal', 'Incisal'],

        people: [],
        isLoadingPeople: false,

        unifyForm: {
          person: null,
          verification: ''
        },

        deleteForm: {
          verification: ''
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        },

        hasMoreTimeline: false,

        appointmentsFilter: {
          dateTime: { startDate: null, endDate: null },
          quantity: 10
        }
      }
    },
    watch: {
      'appointmentsFilter.dateTime': {
        deep: true,
        handler() {
          this.appointmentsFilter.quantity = 10;
        }
      },
      'attendanceForms': {
        deep: true,
        handler(newValue) {
          if(this.attendanceInProgress != null) {
            // localStorage.setItem('attendanceForms_' + this.$route.params.patientId, compressToUTF16(JSON.stringify(newValue)));
            try {
              localStorage.setItem('attendanceForms_' + this.$route.params.patientId, JSON.stringify(newValue));
            } catch (err) {
              this.sentry.captureMessage(JSON.stringify(newValue));
              throw err;
            }
          }
        }
      },
      'attendancePrescriptions': {
        deep: true,
        handler(newValue) {
          if(this.attendanceInProgress != null) {
            localStorage.setItem('attendancePrescriptions_' + this.$route.params.patientId, JSON.stringify(newValue));
          }
        }
      },
      'attendanceGuideForm.item.procedure': {
        handler(newValue) {
          if(newValue != null) {
            this.attendanceGuideForm.item.value = newValue.procedure_value * this.attendanceGuideForm.item.amount;
          }
        }
      },
      'attendanceGuideForm.item.amount': {
        handler(newValue) {
          if(this.attendanceGuideForm.item.procedure != null) {
            this.attendanceGuideForm.item.value = this.attendanceGuideForm.item.procedure.procedure_value * newValue;
          }
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.termSingular = 'paciente';
      this.url = 'pacientes';
      this.module = 'patients';

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_manage');

      this.canManageSubscription = (this.helpers.isOwner())?true:this.helpers.checkPermission('subscription', 'can_manage');

      if(this.canSee == false || this.user.person.type != 'PROFESSIONAL' || !this.helpers.planHasPermission('telehealth')) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.logo = this.user.person.client.logo ? this.user.person.client.logo : ('https://via.placeholder.com/40x40/eaf1f4/11a6f3?text=' + this.userNameInitials);

      document.addEventListener('focusin', function (e) {
        let closest = e.target.closest('.swal2-input');
        if (closest !== null && closest !== undefined) {
          e.stopImmediatePropagation();
        }
      });

      this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowDimensions);
        this.getWindowDimensions();
      });

      await this.api.getTelehealthAppointmentData(this.$route.params.patientId, this.$route.params.id).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.healthPlans = [];
        res.data.health_plans.forEach(health_plan => {
          this.healthPlans.push({ value: health_plan.id, name: health_plan.name });
        });

        this.forms = [];
        res.data.forms.forEach(form => {
          form.fields = form.fields.map(field => {
            field.value = (field.default_value != null && field.default_value != '')?field.default_value:'';
            if(field.type == 'multiple-choice') {
              field.value = (field.value.indexOf(';') > -1)?field.value.split(';'):(field.value !== '' ? [field.value] : []);
            }
            return field;
          });
          this.forms.push({ value: form.id, name: form.name, fields: this.getFieldsInOrder(form.fields) });
        });

        this.agoraToken = res.data.agora_token;
        this.telehealthAppointment = res.data.telehealth_appointment;
        this.telehealthAttendance = res.data.telehealth_attendance;
        this.spectators = res.data.spectators;
        if(this.telehealthAttendance.start_datetime == null) {
          if(!this.telehealthAttendance.patient_entered) {
            this.telehealthCheckInterval = setInterval(this.checkTelehealthAttendance, 15*1000);
          }
          if(res.data.telehealth_available_minutes === 0) {
            this.showTelehealthMinutesEndedWarning();
          }
          else if(res.data.telehealth_available_minutes < (2*this.moment(this.telehealthAppointment.end_datetime).diff(this.moment(this.telehealthAppointment.start_datetime), 'minutes'))) {
            let warningMessage = 'Seus minutos de teleconsulta estão acabando. Você ainda poderá iniciar esta teleconsulta, mas recomendamos que contrate mais minutos para evitar que as próximas sejam bloqueadas.';
            if(this.canManageSubscription) {
              this.$swal({
                title: 'Atenção',
                text: warningMessage,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ajustar assinatura',
                cancelButtonText: 'Entendi',
                focusCancel: true
              }).then((res) => {
                if(res.value) {
                  window.open(this.$router.resolve({ path: '/minha-assinatura' }).href);
                }
              })
            }
            else {
              this.$swal('Atenção', warningMessage + ' Fale com o gestor do seu consultório.', 'warning');
            }
          }
        }
        else if(this.telehealthAttendance.end_datetime == null) {
          this.initializeClient();
          this.joinChannel();
        }

        let patientData = res.data.patient;

        let gender = (patientData.gender == null || typeof patientData.gender == 'undefined') ? 'U' : patientData.gender;
        let address = (patientData.address == null) ? {
          id: null,
          zip_code: '',
          address: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
          country: 'Brazil'
        } : patientData.address;

        this.personForm = {
          id: patientData.id,
          type: patientData.type,
          name: patientData.name,
          internal_code: patientData.internal_code,
          document: patientData.document,
          birthday: (this.moment(patientData.birthday).isValid())?this.moment(patientData.birthday).format('DD/MM/YYYY'):'',
          gender: this.genderOptions.find(g => g.value == gender),
          email: patientData.email,
          telephone: patientData.telephone,
          cellphone: patientData.cellphone,
          health_plan: this.healthPlans.find(g => g.value == patientData.health_plan_id),
          card_number: patientData.card_number,
          notes: patientData.notes,
          address: address,
          health_plans: [],
        };

        patientData.health_plans.forEach(health_plan => {
          this.personForm.health_plans.push({value: health_plan.id, name: health_plan.name});
        });

        this.reminderTypes = [];
        res.data.reminder_types.forEach(reminderType => {
          this.reminderTypes.push({value: reminderType.id, name: reminderType.name});
        });

        this.reminders = res.data.reminders;
        this.units = res.data.units;

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Telehealth Appointment Data', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.canPerformAction = true;
        this.eventBus.$emit('IS_LOADING', false);
        try {
          let msg = 'Não conseguimos carregar este atendimento de teleconsulta! Por favor, entre em contato com o suporte!';
          switch (err.response.status) {
            case 400:
              msg = err.response.data.message;
              break;
          }
          this.$swal('Ops...', msg, 'error');
          this.$router.push({path: '/' + this.url + '/' + this.$route.params.patientId}).catch(() => {});

          this.$swal('Ops...', msg, 'error');
        } catch(err2) {
          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchGetTelehealthAppointmentData\nError:'+err.toString(), 'warning');
          this.sentry.captureException(err);
        }
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Telehealth Appointment Data', err.response);
      });

      await this.getPatientExtraData();

      this.eventBus.$emit('IS_LOADING', false);

      window.addEventListener('message', this.processPrescriptionEvent);
    },
    async updated() {
      if(!this.isMobile) {
        this.adjustScrollbar();
      }
    },
    methods: {
      getWindowDimensions() {
        if(screen.width <= 767 && !this.isMobile) {
          this.isMobile = true;
        } else if(screen.width >= 768 && this.isMobile) {
          this.isMobile = false;
        }
      },

      async getPatientExtraData() {
        this.canPerformAction = false;

        await this.api.getPersonAppointments(this.$route.params.patientId).then(res => {
          if(this.leavingPage) {
            return;
          }
          this.appointments = res.data;
          this.futureAppointments = this.appointments.filter(appointment => {
            return this.moment(appointment.start_datetime).isAfter(this.moment(), 'day');
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Person Appointments', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar os agendamentos deste ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Person Appointments', err.response);
        });

        await this.api.getPersonAttendances(this.$route.params.patientId).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          this.attendances = res.data;

          if(this.attendances.length > 0) {
            this.attendances.forEach(attendance => {
              if(attendance.end_datetime == null && attendance.appointment_id == this.telehealthAppointment.id) {
                this.attendanceInProgress = attendance;
                this.attendanceStartDatetime = attendance.start_datetime;
                if(this.interval != null) {
                  clearInterval(this.interval);
                }
                this.interval = setInterval(this.setTimer, 1000);

                if(this.decompressAttendanceForm('attendanceForms_' + this.$route.params.patientId) != null)
                  this.attendanceForms = this.decompressAttendanceForm('attendanceForms_' + this.$route.params.patientId);
                else if(this.decompressAttendanceForm('attendanceForms') != null) {
                  this.attendanceForms = this.decompressAttendanceForm('attendanceForms');
                  // localStorage.setItem('attendanceForms_' + this.$route.params.patientId, compressToUTF16(JSON.stringify(this.attendanceForms)));
                  try {
                    localStorage.setItem('attendanceForms_' + this.$route.params.patientId, JSON.stringify(this.attendanceForms));
                  } catch (err) {
                    this.sentry.captureMessage(JSON.stringify(this.attendanceForms));
                    throw err;
                  }
                  localStorage.removeItem('attendanceForms');
                }
                if(JSON.parse(localStorage.getItem('attendancePrescriptions_' + this.$route.params.patientId)) != null)
                  this.attendancePrescriptions = JSON.parse(localStorage.getItem('attendancePrescriptions_' + this.$route.params.patientId));
                else if(JSON.parse(localStorage.getItem('attendancePrescriptions')) != null) {
                  let attendancePrescriptionsString = localStorage.getItem('attendancePrescriptions');
                  this.attendancePrescriptions = JSON.parse(attendancePrescriptionsString);
                  localStorage.setItem('attendancePrescriptions_' + this.$route.params.patientId, attendancePrescriptionsString);
                  localStorage.removeItem('attendancePrescriptions');
                }
              }
              attendance.forms.map(form => {
                form.fields = form.fields.map(field => {
                  if(field.type == 'multiple-choice')
                    field.value = (field.value.indexOf(';') > -1)?field.value.split(';'):(field.value !== '' ? [field.value] : []);

                  return field;
                });
              });
            });
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Person Attendances', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar os atendimentos deste ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Person Attendances', err.response);
        });

        await this.api.getPersonAttendanceGuides(this.$route.params.patientId).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          this.attendanceGuides = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Person Attendance Guides', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar as guias de atendimento deste ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Person Attendance Guides', err.response);
        });
      },

      decompressAttendanceForm(key) {
        let attendanceFormsString = localStorage.getItem(key);
        if(attendanceFormsString == null) {
          return null;
        }
        if(attendanceFormsString.indexOf('{') === 0 || attendanceFormsString.indexOf('[') === 0) {
          try {
            let attendanceForms = JSON.parse(attendanceFormsString);
            if(attendanceForms != null) {
              return attendanceForms;
            }
          } catch(err) {
            console.log('parse attendance error', err);
          }
        }
        try {
          // return JSON.parse(decompressFromUTF16(attendanceFormsString));
          return JSON.parse(attendanceFormsString);
        } catch(err) {
          console.log('parse attendance error', err);
          return null;
        }
      },

      async startAttendanceAppointment(appointmentId) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        await this.api.startAttendanceAppointment(appointmentId).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          if (res.status == 201) {
            this.attendanceInProgress = res.data;
            this.attendanceStartDatetime = res.data.start_datetime;
            if(this.interval != null) {
              clearInterval(this.interval);
            }
            this.interval = setInterval(this.setTimer, 1000);
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Start Attendance', res);
        }).catch(err => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let msg = 'Não conseguimos iniciar o atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 400: msg = err.response.data.message; break;
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Start Attendance', err.response);
        });
      },

      async endAttendance() {
        if(!this.canPerformAction || !this.$refs.attendanceForms)
          return false;

        const isValid = await this.$refs.attendanceForms.validate();
        if(!isValid) {
          return false;
        }

        this.$swal({
          title: 'Encerrar atendimento',
          text: 'Tem certeza que deseja encerrar este atendimento? As informações salvas não poderão ser alteradas.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Encerrar',
          cancelButtonText: 'Cancelar',
          focusConfirm: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            let attendanceData = {
              fields: [],
              prescriptions: []
            };

            this.attendanceForms.forEach(attendanceForm => {
              if(attendanceForm.form != null) {
                attendanceForm.form.fields.forEach(field => {
                  if(field.type == 'attachments') {
                    if(field.value != '') {
                      let attachments = [];
                      field.value.forEach(attachment => {
                        if(attachment.file != null) {
                          attachments.push({file:attachment.file,file_name:attachment.file_name,name:attachment.name != '' ? attachment.name : attachment.file_name});
                        }
                      });
                      if(attachments.length > 0)
                        attendanceData.fields.push({ id: field.id, type: field.type, value: attachments });
                    }
                  }
                  else if(field.value != '' || field.type == 'boolean')
                    attendanceData.fields.push({ id: field.id, type: field.type, value: (field.type == 'multiple-choice' && typeof field.value != 'string')?field.value.join(';'):field.value });
                });
              }
            });
            this.attendancePrescriptions.forEach(attendancePrescription => {
              attendanceData.prescriptions.push({ value: attendancePrescription.value });
            });

            this.api.endPersonAttendance(this.$route.params.patientId, attendanceData).then(res => {
              this.canPerformAction = true;
              if(this.leavingPage) {
                return;
              }

              if(this.interval != null)
                clearInterval(this.interval);

              if(this.telehealthCheckInterval != null)
                clearInterval(this.telehealthCheckInterval);

              if(this.telehealthAttendance.end_datetime == null) {
                this.telehealthAttendance.end_datetime = 1;
              }

              this.attendanceForms = [];
              localStorage.removeItem('attendanceForms');
              localStorage.removeItem('attendanceForms_' + this.$route.params.patientId);
              this.attendancePrescriptions = [];
              localStorage.removeItem('attendancePrescriptions');
              localStorage.removeItem('attendancePrescriptions_' + this.$route.params.patientId);

              this.currentPrescription = null;
              this.attendanceInProgress = null;
              this.attendanceStartDatetime = null;
              this.interval = null;
              this.telehealthCheckInterval = null;
              this.timer = null;

              this.$swal('Uhull \\o/', 'Atendimento finalizado. Esta aba será fechada.', 'success').then(() => {
                window.close();
              });

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response End Attendance', res);
            }).catch(err => {
              this.canPerformAction = true;
              if(this.leavingPage) {
                return;
              }

              let msg = 'Não conseguimos encerrar o atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 400: msg = err.response.data.message; break;
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error End Attendance', err.response);
            });
          }
        });
      },

      async checkTelehealthAttendance() {
        await this.api.checkTelehealthAttendance(this.$route.params.patientId, this.telehealthAttendance.id).then(res => {
          if(this.leavingPage) {
            return;
          }
          this.telehealthAttendance = res.data;
          if(this.telehealthAttendance.start_datetime != null || this.telehealthAttendance.patient_entered) {
            clearInterval(this.telehealthCheckInterval)
            this.telehealthCheckInterval = null;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Check Telehealth Attendance', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Check Telehealth Attendance', err.response);
        });
      },

      showTelehealthMinutesEndedWarning() {
        let warningMessage = 'Seus minutos de teleconsulta acabaram, não será possível iniciar esta teleconsulta. Você pode contratar mais minutos ou aguardar a renovação da sua assinatura para desbloquear as teleconsultas.';
        if(this.canManageSubscription) {
          this.$swal({
            title: 'Atenção',
            text: warningMessage,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ajustar assinatura',
            cancelButtonText: 'Entendi',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              window.open(this.$router.resolve({ path: '/minha-assinatura' }).href);
            }
          })
        }
        else {
          this.$swal('Atenção', warningMessage + ' Fale com o gestor do seu consultório.', 'warning');
        }
      },
      initializeClient() {
        this.agoraClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
        this.setupAgoraEventListeners();
      },
      setupAgoraEventListeners() {
        this.agoraClient.on('user-published', async (user, mediaType) => {
          if(!this.leftChannel) {
            await this.agoraClient.subscribe(user, mediaType);
            this.loadParticipants();
          }
        });

        this.agoraClient.on('user-unpublished', async (user) => {
          if(!this.leftChannel) {
            let remotePlayerContainer = document.getElementById(user.uid);
            if(remotePlayerContainer) {
              let audioIndicator = remotePlayerContainer.querySelectorAll('.participant-audio.participant-' + user.uid)[0],
                  noAudioIndicator = remotePlayerContainer.querySelectorAll('.participant-no-audio.participant-' + user.uid)[0];
              audioIndicator.style.display = user.hasVideo || !user.hasAudio ? 'none' : 'block';
              noAudioIndicator.style.display = user.hasAudio ? 'none' : 'block';
            }
          }
        });

        this.agoraClient.on('user-left', async (user) => {
          if(!this.leftChannel) {
            let remotePlayerContainer = document.getElementById(user.uid);
            if (remotePlayerContainer) {
              remotePlayerContainer && remotePlayerContainer.remove();
            }
            setTimeout(() => {
              let container = document.getElementById('participants');
              if(container) {
                container.style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);
              }
              else {
                setTimeout(() => {
                  let container = document.getElementById('participants');
                  if(container) {
                    container.style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);
                  }
                }, 500);
              }
            }, 500);
          }
        });
      },

      async joinChannel() {
        await this.agoraClient.join(this.agoraId, this.telehealthAttendance.id, this.agoraToken, this.user.person.id);
        await this.createLocalMediaTracks();
        await this.publishLocalTracks();
        this.loadParticipants();
        this.loadedChannel = true;
      },
      async createLocalMediaTracks() {
        this.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
        this.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
      },
      async publishLocalTracks() {
        await this.agoraClient.publish([this.localAudioTrack, this.localVideoTrack]);
      },
      loadParticipants() {
        if(!this.localVideoTrack) {
          return;
        }
        let container = document.getElementById('participants');
        if(!container) {
          setTimeout(() => {
            this.loadParticipants();
          }, 500);
          return;
        }
        container.style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);
        if(!document.getElementById(this.user.person.id)) {
          this.displayLocalVideo(container);
        }
        let patientUser = this.agoraClient.remoteUsers.find(user => user.uid === this.personForm.id);
        if(patientUser) {
          this.displayRemoteVideo(container, 'Paciente ' + this.personForm.name, patientUser, -10);
        }

        this.agoraClient.remoteUsers.forEach((user) => {
          if(user.uid !== this.personForm.id) {
            let spectator = this.spectators.find(spectator => spectator.id === user.uid);
            this.displayRemoteVideo(container, spectator ? spectator.name : '', user, null);
          }
        });
      },
      displayLocalVideo(container) {
        container.insertAdjacentHTML('beforeend', '' +
          '<div id="' + this.user.person.id + '" style="display: flex; flex: 1 1 0; height: 100%; width: 100%; order: -5">' +
            '<div style="display: flex; flex: 1 1 0; position: relative">' +
              '<p style="position: absolute; background: rgba(0, 123, 255, 0.667); padding: 2px 8px; color: rgb(255, 255, 255); margin: 0px; bottom: 0px; right: 0px; z-index: 90;">' + this.user.person.name + '</p>' +
              '<div class="participant-video participant-' + this.user.person.id + '" style="flex: 1 1 0%; display: flex; background-color: rgba(0, 123, 255, 0.2); flex-direction: row; position: relative;"></div>' +
              '<i class="fas fa-microphone text-white participant-audio participant-' + this.user.person.id + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none"></i>' +
              '<div class="text-white participant-no-audio participant-' + this.user.person.id + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none">' +
                '<div style="display:inline;border-radius:100%;background: rgba(0,0,0,0.2)"><i class="fas fa-microphone-slash" style="opacity:.85"></i></div>' +
              '</div>' +
            '</div>' +
          '</div>');
        this.localVideoTrack.play(document.querySelectorAll('.participant-video.participant-' + this.user.person.id)[0]);
      },
      displayRemoteVideo(container, name, user, order) {
        if(!document.getElementById(user.uid)) {
          container.insertAdjacentHTML('beforeend', '' +
              '<div id="' + user.uid + '" style="display: flex; flex: 1 1 0; height: 100%; width: 100%; ' + (order !== null ? ('order: ' + order) : '') + '">' +
                '<div style="display: flex; flex: 1 1 0; position: relative">' +
                  '<p style="position: absolute; background: rgba(0, 123, 255, 0.667); padding: 2px 8px; color: rgb(255, 255, 255); margin: 0px; bottom: 0px; right: 0px; z-index: 90;">' + name + '</p>' +
                  '<div class="participant-video participant-' + user.uid + '" style="flex: 1 1 0%; display: flex; background-color: rgba(0, 123, 255, 0.2); flex-direction: row; position: relative;"></div>' +
                  '<i class="fas fa-microphone participant-audio participant-' + user.uid + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none"></i>' +
                  '<div class="text-white participant-no-audio participant-' + user.uid + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none">' +
                    '<div style="display:inline;border-radius:100%;background: rgba(0,0,0,0.2)"><i class="fas fa-microphone-slash" style="opacity:.85"></i></div>' +
                  '</div>' +
                '</div>' +
              '</div>');
        }
        if(user.hasVideo && user.videoTrack && !user.videoTrack.isPlaying) {
          user.videoTrack.play(document.querySelectorAll('.participant-video.participant-' + user.uid)[0]);
        }
        if(user.hasAudio && user.audioTrack && !user.audioTrack.isPlaying) {
          user.audioTrack.play();
        }
        let audioIndicator = document.querySelectorAll('.participant-audio.participant-' + user.uid)[0],
            noAudioIndicator = document.querySelectorAll('.participant-no-audio.participant-' + user.uid)[0];
        if(audioIndicator) {
          audioIndicator.style.display = user.hasVideo || !user.hasAudio ? 'none' : 'block';
        }
        if(noAudioIndicator) {
          noAudioIndicator.style.display = user.hasAudio ? 'none' : 'block';
        }
      },
      getAgoraGridStyle(amount) {
        let gridCellStyle = 'minmax(0px, 1fr)',
            gridStyle = [gridCellStyle];
        if(amount > 1) {
          gridStyle.push(gridCellStyle);
          if(amount > 4) {
            gridStyle.push(gridCellStyle);
          }
        }
        return gridStyle.join(' ');
      },
      toggleCamera() {
        this.videoEnabled = !this.videoEnabled;
        if(this.localVideoTrack) {
          this.localVideoTrack.setEnabled(this.videoEnabled);
        }
        let participantAudio = document.querySelectorAll('.participant-audio.participant-' + this.user.person.id);
        if(participantAudio) {
          participantAudio[0].style.display = this.videoEnabled || this.audioMuted ? 'none' : 'block';
        }
        let participantNoAudio = document.querySelectorAll('.participant-no-audio.participant-' + this.user.person.id);
        if(participantNoAudio) {
          participantNoAudio[0].style.display = !this.audioMuted ? 'none' : 'block';
        }
      },
      toggleMicrophone() {
        this.audioMuted = !this.audioMuted;
        if(this.localAudioTrack) {
          this.localAudioTrack.setEnabled(this.audioMuted);
        }
        let participantAudio = document.querySelectorAll('.participant-audio.participant-' + this.user.person.id);
        if(participantAudio) {
          participantAudio[0].style.display = this.videoEnabled || this.audioMuted ? 'none' : 'block';
        }
        let participantNoAudio = document.querySelectorAll('.participant-no-audio.participant-' + this.user.person.id);
        if(participantNoAudio) {
          participantNoAudio[0].style.display = !this.audioMuted ? 'none' : 'block';
        }
      },
      async leaveChannel() {
        this.leftChannel = true;
        if (this.localAudioTrack) {
          this.localAudioTrack.close();
          this.localAudioTrack = null;
        }
        if (this.localVideoTrack) {
          this.localVideoTrack.close();
          this.localVideoTrack = null;
        }
        let container = document.getElementById('participants');
        if(container) {
          container.innerHTML = '';
        }
        await this.agoraClient.leave();
      },

      async startTelehealthAttendance() {
        if(!this.canPerformAction)
          return false;

        let doStart = true;
        if(!this.telehealthAttendance.patient_entered) {
          doStart = false;
          await this.$swal({
            title: 'Você tem certeza de que deseja iniciar a teleconsulta? O paciente ainda não entrou.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Iniciar',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doStart = true;
            }
          })
        }
        if(!doStart)
          return false;

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        await this.api.startTelehealthAttendance(this.$route.params.patientId, this.telehealthAttendance.id).then(res => {
          this.canPerformAction = true;
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.initializeClient();
          this.joinChannel();

          this.attendanceInProgress = res.data.attendance_in_progress;
          this.attendanceStartDatetime = res.data.attendance_in_progress.start_datetime;
          if(this.interval != null) {
            clearInterval(this.interval);
          }
          this.interval = setInterval(this.setTimer, 1000);
          this.telehealthAttendance = res.data.telehealth_attendance;
          if(this.telehealthCheckInterval != null) {
            clearInterval(this.telehealthCheckInterval)
            this.telehealthCheckInterval = null;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Start Telehealth Attendance', res);
        }).catch(err => {
          this.canPerformAction = true;
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          let msg = 'Não conseguimos iniciar a teleconsulta! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 400: msg = err.response.data.message; break;
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          if(msg === 'Seus minutos de teleconsulta acabaram!') {
            this.showTelehealthMinutesEndedWarning();
          }
          else {
            this.$swal('Ops...', msg, 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Start Telehealth Attendance', err.response);
        });
      },

      async endTelehealthAttendance() {
        if(!this.canPerformAction)
          return false;

        this.$swal({
          title: 'Encerrar chamada',
          text: 'Tem certeza que deseja encerrar esta chamada de teleconsulta? A chamada será finalizada, mas o atendimento continuará aberto para que você possa finalizá-lo.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Encerrar chamada',
          cancelButtonText: 'Cancelar',
          focusConfirm: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);

            this.api.endTelehealthAttendance(this.$route.params.patientId, this.telehealthAttendance.id).then(res => {
              this.canPerformAction = true;
              this.eventBus.$emit('IS_LOADING', false);
              if(this.leavingPage) {
                return;
              }
              this.telehealthAttendance = res.data;
              this.leaveChannel();
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response End Telehealth Attendance', res);
            }).catch(err => {
              this.canPerformAction = true;
              this.eventBus.$emit('IS_LOADING', false);
              if(this.leavingPage) {
                return;
              }

              let msg = 'Não conseguimos encerrar a teleconsulta! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 400: msg = err.response.data.message; break;
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error End Telehealth Attendance', err.response);
            });
          }
        });
      },

      setTimer() {
        let now = this.moment();
        let diff = now.diff(this.moment(this.attendanceStartDatetime), 'seconds');

        this.timer = this.moment.duration(diff, 'seconds').format('hh:mm:ss', { trim: false });
      },

      getAvailableForms(currentForm) {
        let formsInUser = this.attendanceForms.map(attendanceForm => (attendanceForm.form != null && attendanceForm.form.hasOwnProperty('value'))?attendanceForm.form.value:null);

        return this.forms.filter(form => !formsInUser.includes(form.value) || (currentForm != null && form.value == currentForm.value));
      },

      showAddNewButton() {
        return (this.attendanceForms.length > 0 && this.attendanceForms.filter(attendanceForm => attendanceForm.form == null).length > 0)?false:true;
      },

      showAddNewPrescriptionButton() {
        return this.user != null && this.user.person.client.enable_digital_prescriptions == 1 && this.user.person.enable_professional_digital_prescriptions == 1 && this.attendanceInProgress != null;
      },

      addNewFormToAttendance() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.attendanceForms.push({
          'id': this.helpers.uuidv4(),
          'form': null
        });
        this.canPerformAction = true;
      },

      removeAttendanceForm(attendanceFormId, formId) {
        this.attendanceForms = this.attendanceForms.filter(attendanceForm => attendanceForm.id != attendanceFormId);

        if(formId != null)
          this.forms.map(form => {
            if(form.value == formId)
              form.fields.forEach(field => {
                field.value = (field.default_value != null && field.default_value != '')?field.default_value:'';

                return field;
              });

            return form;
          });
      },

      removePrescription(prescription) {
        if(!this.canPerformAction || this.attendanceInProgress == null || this.user.person.professional_registration == null)
          return false;

        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover receituário',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;

            this.eventBus.$emit('IS_LOADING', true);

            this.api.deletePrescription(prescription.external_id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              this.attendancePrescriptions = this.attendancePrescriptions.filter(attendancePrescription => attendancePrescription.id != prescription.id);

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Prescription', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              this.$swal('Ops...', 'Não conseguimos remover o receituário digital. Por favor, entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Prescription', err.response);
            });
          }
        });
      },

      showTab(tab) {
        if(this.activeTab != tab) {
          this.activeTab = tab;
          this.appointmentsFilter.quantity = 10;
        }
        this.showPastAppointments = tab === 'past-appointments';
      },

      adjustScrollbar() {
        let menuBox1 = document.getElementById('attendance_menu_box1'),
            menuBox2 = document.getElementById('attendance_menu_box2');
        if(menuBox1 && menuBox2) {
          let totalHeight = document.body.offsetHeight - 24,
              box1Height = menuBox1.offsetHeight,
              box2Height = menuBox2.offsetHeight,
              newHeight = totalHeight - box1Height - Math.max(box2Height - this.scrollbarHeight, 0);

          if(newHeight > 400 && this.scrollbarHeight !== newHeight) {
            this.scrollbarHeight = newHeight;
          }
        }
      },

      getPersonTimeline() {
        let personTimeline = [];

        if(this.showPastAppointments) {
          this.attendances.forEach(attendance => {
            if(attendance.forms.length > 0 || attendance.prescriptions.length > 0) {
              personTimeline.push(this.moment(attendance.start_datetime).format('YYYY-MM-DD'));
            }
          });
        }

        this.appointments.forEach(appointment => {
          let appointmentDatetime = this.moment(appointment.start_datetime);
          if(!appointmentDatetime.isSame(this.moment(), 'day') || ['ATTENDED', 'FINISHED'].includes(appointment.status)) {
            if((this.showPastAppointments && appointmentDatetime.isSameOrBefore(this.moment(), 'day')) || (!this.showPastAppointments && appointmentDatetime.isAfter(this.moment(), 'day'))) {
              personTimeline.push(appointmentDatetime.format('YYYY-MM-DD'));
            }
          }
        });

        personTimeline = personTimeline.sort((a, b) => this.moment(b).diff(this.moment(a)));
        personTimeline = [... new Set(personTimeline)];


        if(this.appointmentsFilter.dateTime.startDate != null) {
          let startDate = this.moment(this.appointmentsFilter.dateTime.startDate),
            endDate = this.moment(this.appointmentsFilter.dateTime.endDate),
            filterRange = this.moment().range(startDate, endDate);

          personTimeline = personTimeline.filter(date => {
            return filterRange.contains(this.moment(date));
          });
        }
        if(!this.showPastAppointments) {
          personTimeline = personTimeline.reverse();
        }

        this.hasMoreTimeline = (personTimeline.length > this.appointmentsFilter.quantity);
        personTimeline = personTimeline.slice(0, this.appointmentsFilter.quantity);
        return personTimeline;
      },

      getInfoByDate(date) {
        date = this.moment(date);

        return {
          attendances: this.attendances.filter(attendance => {
            return this.moment(attendance.start_datetime).isSame(date, 'day');
          }),
          appointments: this.appointments.filter(appointment => {
            let appointmentDatetime = this.moment(appointment.start_datetime);
            return appointmentDatetime.isSame(date, 'day') && (!appointmentDatetime.isSame(this.moment(), 'day') || ['ATTENDED', 'FINISHED'].includes(appointment.status));
          })
        };
      },

      attendancesWithFormsOrPrescriptions(attendances) {
        let attendancesWithFormsOrPrescriptions = attendances.filter(attendance => {
          return attendance.forms.length > 0 || attendance.prescriptions.length > 0;
        });
        return attendancesWithFormsOrPrescriptions.length > 0;
      },

      showForm(form, attendance) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.formSelected = form;
        this.formSelectedAttendanceId = attendance.id;
        this.formSelectedProfessionalId = attendance.professional_id;
        this.formSelectedShowNotes = form.notes.length > 0 && (((this.user.person.client.enable_coordinator_profile || this.user.person.client.enable_professional_notes) && this.user.person.id == attendance.professional_id) || (this.user.person.client.enable_coordinator_profile && this.user.person.type == 'COORDINATOR'));
        this.formSelectedNote = '';
        this.formSelected.professional = attendance.professional.name;
        this.formSelected.created_at = attendance.start_datetime;

        this.formSelected.unit = attendance.unit_id != null ? this.units.find(g => g.id == attendance.unit_id) : this.user.person.client.default_unit;

        // this.formSelected.fields.map(field => {
        //   if(field.type == 'multiple-choice')
        //     field.value = (field.value.indexOf(';') > -1)?field.value.split(';'):(field.value !== '' ? [field.value] : []);
        //
        //   return field;
        // });

        this.$bvModal.show('form-modal');
        this.canPerformAction = true;
      },

      async saveFormNote() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.noteForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }
        this.eventBus.$emit('IS_LOADING', true);

        let noteData = {
          form_id: this.formSelected.id,
          value: this.formSelectedNote
        };

        this.api.storeAttendanceFormNote(this.formSelectedAttendanceId, noteData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.formSelectedNote = '';
          this.$refs.noteForm.reset();
          this.formSelected.notes.push(res.data);

          this.$swal('Uhull \\o/', 'A anotação foi enviada com sucesso!', 'success');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Store Form Note', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos salvar esta anotação! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Store Form Note', err.response);
        });
      },

      resetFormModal() {
        this.formSelected = null;
      },

      deleteAttendanceGuide(attendanceGuide) {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Excluir guia de atendimento',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deleteAttendanceGuide(attendanceGuide.appointment_id, attendanceGuide.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.getPatientExtraData();

                this.$swal('Uhull \\o/', 'A guia de atendimento foi excluída com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir a guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Attendance Guide', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Attendance Guide', err.response);
            });
          }
        });
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      print() {
        window.print();
      },

      getFieldsInOrder(fields) {
        fields = this.helpers.clone(fields);

        return fields.sort((a, b) => {
          if(a.order < b.order) return -1;
          if(a.order > b.order) return 1;
          return 0;
        });
      },

      cleanAppointmentsFilter() {
        this.appointmentsFilter = {
          dateTime: { startDate: null, endDate: null },
          quantity: 10
        }
      },

      loadMoreAppointments() {
        this.appointmentsFilter.quantity += 10;
      },

      showFullHistory() {
        this.appointmentsFilter.quantity = 1000;

        this.$bvModal.show('history-modal');
      },

      resetAttendanceGuideModal() {
        this.attendanceGuideForm = {
          id: null,
          appointment_id: null,
          start_datetime: '',
          internal_id: '',
          name: '',
          professional: {
            name: '',
            specialities: [],
          },
          is_dentist: false,
          health_plan: '',
          bill_type: '',
          pending: true,
          items: [],
          invoiceStatements: [],
          invoices: [],
          item: {
            tooth: null,
            faces: null,
            procedure: null,
            amount: 1,
            value: 0,
            accomplished: false
          }
        };
      },

      findAttendanceGuideProcedures(query) {
        this.attendanceGuideProcedures = [];
        if(query.length >= 3 && !this.isLoadingAttendanceGuideProcedures) {
          if(this.findAttendanceGuideProceduresTimer !== null) {
            clearTimeout(this.findAttendanceGuideProceduresTimer);
          }
          this.findAttendanceGuideProceduresTimer = setTimeout(() => {
            this.isLoadingAttendanceGuideProcedures = true;
            this.api.getProcedures({ term: query }).then(res => {
              if(this.leavingPage) {
                return;
              }
              this.isLoadingAttendanceGuideProcedures = false;

              this.attendanceGuideProcedures = res.data.data.map(procedure => {
                return { value: procedure.id, name: procedure.name, procedure_value: procedure.value, cnae: procedure.cnae };
              });
            }).catch(err => {
              if(this.leavingPage) {
                return;
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error AttendanceGuideProcedures', err.response);
            });
          }, 300);
        }
      },

      async addItemToAttendanceGuide() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.attendanceGuideItemForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let item = this.attendanceGuideForm.item;
        if(item.faces != null) {
          item.faces = item.faces.join(', ');
        }
        this.attendanceGuideForm.items.push(item);

        this.attendanceGuideForm.item = {
          tooth: null,
          faces: null,
          procedure: null,
          amount: 1,
          value: 0,
          accomplished: false
        };

        this.$refs.attendanceGuideItemForm.reset();
        this.canPerformAction = true;
      },

      async removeItemFromAttendanceGuide(index) {
        this.attendanceGuideForm.items.splice(index, 1);
      },

      async billAttendanceGuide() {
        if(!this.canPerformAction)
          return false;

        const isValid = await this.$refs.attendanceGuideForm.validate();
        if(!isValid) {
          return false;
        }
        if(this.attendanceGuideForm.items.length === 0) {
          this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
          return false;
        }
        if(this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null).length === 0) {
          this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
          return false;
        }

        if(this.user.person.client.enable_mandic_nf) {
          let items = this.attendanceGuideForm.items,
              cnaes = [];
          if(this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
            items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
          }
          items.forEach(item => {
            if(cnaes.indexOf(item.procedure.cnae) === -1) {
              cnaes.push(item.procedure.cnae);
            }
          });
          if(cnaes.length > 1) {
            this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
            return false;
          }
        }

        this.attendanceGuideForm.authorization_code = '';

        if(this.attendanceGuideForm.health_plan !== 'Particular') {
          let { value: authorizationCode } = await this.$swal({
            title: 'N° de Autorização de Guia de Atendimento',
            text: 'Informe o número de autorização para faturamento ' + (this.attendanceGuideForm.id == null ? 'desta guia' : ('da guia ' + this.attendanceGuideForm.internal_id)),
            input: 'text',
            inputLabel: 'Número de autorização',
            inputAttributes: {
              maxlength: 100,
            },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
              if (!value) {
                return 'Você tem que preencher o número de autorização!'
              }
            }
          });
          if(authorizationCode) {
            this.attendanceGuideForm.authorization_code = authorizationCode;
            this.saveAttendanceGuide(true);
          }
        }
        else {
          this.saveAttendanceGuide(true);
        }
      },

      async saveAttendanceGuide(bill) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.attendanceGuideForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }
        if(this.attendanceGuideForm.items.length === 0) {
          this.canPerformAction = true;
          this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
          return false;
        }
        if(bill && this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null).length === 0) {
          this.canPerformAction = true;
          this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
          return false;
        }

        if(bill && this.user.person.client.enable_mandic_nf) {
          let items = this.attendanceGuideForm.items,
              cnaes = [];
          if(this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
            items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
          }
          items.forEach(item => {
            if(cnaes.indexOf(item.procedure.cnae) === -1) {
              cnaes.push(item.procedure.cnae);
            }
          });
          if(cnaes.length > 1) {
            this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
            return false;
          }
        }

        let attendanceGuideData = {
          bill_type: this.attendanceGuideForm.bill_type != null ? this.attendanceGuideForm.bill_type.value : null,
          bill: bill,
          authorization_code: bill ? this.attendanceGuideForm.authorization_code : null,
          items: this.attendanceGuideForm.items.map(item => {
            return {
              id: item.id,
              procedure_id: item.procedure.value,
              tooth: item.tooth,
              faces: item.faces,
              amount: item.amount,
              value: item.value,
              accomplished: item.accomplished
            }
          })
        };

        this.eventBus.$emit('IS_LOADING', true);
        if(this.attendanceGuideForm.id == null) {
          attendanceGuideData.health_plan_id = this.attendanceGuideForm.health_plan_id;

          await this.api.storeAttendanceGuide(this.attendanceGuideForm.appointment_id, attendanceGuideData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$bvModal.hide('attendance-guide-modal');
              if(bill) {
                let transactionId = res.data.id;
                this.$swal('Uhull \\o/', 'A guia de atendimento foi cadastrada com sucesso! Agora finalize o cadastro da fatura.', 'success').then(() => {
                  this.$router.push({path: '/financeiro/contas-a-receber/' + transactionId}).catch(() => {});
                });
              }
              else {
                this.getPatientExtraData();
                this.$swal('Uhull \\o/', 'A guia de atendimento foi cadastrada com sucesso!', 'success');
              }
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Attendance Guide', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos cadastrar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Attendance Guide', err.response);
          });
        }
        else {
          await this.api.updateAttendanceGuide(this.attendanceGuideForm.appointment_id, this.attendanceGuideForm.id, attendanceGuideData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$bvModal.hide('attendance-guide-modal');
              if(bill) {
                let transactionId = res.data.id;
                this.$swal('Uhull \\o/', 'A guia de atendimento foi atualizada com sucesso! Agora finalize o cadastro da fatura.', 'success').then(() => {
                  this.$router.push({path: '/financeiro/contas-a-receber/' + transactionId}).catch(() => {});
                });
              }
              else {
                this.getPatientExtraData();
                this.$swal('Uhull \\o/', 'A guia de atendimento foi atualizada com sucesso!', 'success');
              }
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Attendance Guide', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos atualizar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Attendance Guide', err.response);
          });
        }
      },

      showAttendanceGuideModal(attendanceGuide) {
        if(!this.canPerformAction)
          return false;

        if(attendanceGuide != null) {
          this.attendanceGuideForm.id = attendanceGuide.id;
          this.attendanceGuideForm.appointment_id = attendanceGuide.appointment_id;
          this.attendanceGuideForm.start_datetime = this.moment(attendanceGuide.appointment.start_datetime).format('DD/MM/YYYY HH:mm');
          this.attendanceGuideForm.internal_id = attendanceGuide.internal_id;
          this.attendanceGuideForm.name = attendanceGuide.patient.name;
          this.attendanceGuideForm.professional = attendanceGuide.appointment.professional;
          this.attendanceGuideForm.professional.commission_percentage = this.attendanceGuideForm.professional.commission_percentage != null ? this.attendanceGuideForm.professional.commission_percentage : 0;
          this.attendanceGuideForm.health_plan = attendanceGuide.appointment.health_plan.name;
          this.attendanceGuideForm.bill_type = this.billTypeOptions.find(billType => billType.value == attendanceGuide.bill_type);
          this.attendanceGuideForm.pending = attendanceGuide.pending;
          this.attendanceGuideForm.items = attendanceGuide.items;
          this.attendanceGuideForm.invoices = attendanceGuide.attendance_guide_invoices != null ? attendanceGuide.attendance_guide_invoices : [];
          this.attendanceGuideForm.invoices.forEach(invoice => {
            invoice.transactions = invoice.transactions.sort((a, b) => (a.charge_date > b.charge_date)?1:-1);
          });
          let dentistSpecialty = attendanceGuide.appointment.professional.specialities.find(specialty => {
            return specialty.group === 'Odontologia';
          });
          this.attendanceGuideForm.is_dentist = dentistSpecialty !== undefined;
        }
        else {
          this.attendanceGuideForm.id = null;
          this.attendanceGuideForm.appointment_id = this.telehealthAppointment.id;
          this.attendanceGuideForm.start_datetime = this.moment(this.telehealthAppointment.start_datetime).format('DD/MM/YYYY HH:mm');
          this.attendanceGuideForm.internal_id = '';
          this.attendanceGuideForm.name = this.personForm.name;
          this.attendanceGuideForm.professional = this.telehealthAppointment.professional;
          this.attendanceGuideForm.professional.commission_percentage = this.attendanceGuideForm.professional.commission_percentage != null ? this.attendanceGuideForm.professional.commission_percentage : 0;
          this.attendanceGuideForm.health_plan = this.telehealthAppointment.health_plan.name;
          this.attendanceGuideForm.health_plan_id = this.telehealthAppointment.health_plan.id;
          this.attendanceGuideForm.bill_type = this.helpers.planHasPermission('financial') ? null : this.billTypeOptions.find(g => g.value == 'full_guide');
          this.attendanceGuideForm.pending = true;
          this.attendanceGuideForm.items = [];
          this.attendanceGuideForm.invoices = [];
          let dentistSpecialty = this.telehealthAppointment.professional.specialities.find(specialty => {
            return specialty.group === 'Odontologia';
          });
          this.attendanceGuideForm.is_dentist = dentistSpecialty !== undefined;
        }

        // this.attendanceGuideForm
        this.$bvModal.show('attendance-guide-modal');
        this.canPerformAction = true;
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      async addNewPrescriptionToAttendance() {
        if(!this.canPerformAction || this.attendanceInProgress == null || this.user.person.professional_registration == null)
          return false;

        let personAddress = this.personForm.address;
        if(this.isNullOrEmpty(this.personForm.document) || this.isNullOrEmpty(this.personForm.cellphone) || this.isNullOrEmpty(this.personForm.gender.value) || personAddress == null
            || this.isNullOrEmpty(personAddress.zip_code) || this.isNullOrEmpty(personAddress.address) || this.isNullOrEmpty(personAddress.number) || this.isNullOrEmpty(personAddress.city)
            || this.isNullOrEmpty(personAddress.state)) {
          let missingFields = [];
          if(this.isNullOrEmpty(this.personForm.document)) {
            missingFields.push('CPF');
          }
          if(this.isNullOrEmpty(this.personForm.cellphone)) {
            missingFields.push('celular');
          }
          if(this.isNullOrEmpty(this.personForm.gender.value)) {
            missingFields.push('sexo');
          }
          if(personAddress == null || this.isNullOrEmpty(personAddress.zip_code) || this.isNullOrEmpty(personAddress.address) || this.isNullOrEmpty(personAddress.number) || this.isNullOrEmpty(personAddress.city) || this.isNullOrEmpty(personAddress.state)) {
            missingFields.push('endereço completo');
          }
          missingFields = missingFields.join(', ').replace(/,(?=[^,]*$)/, ' e');

          this.$swal({
            title: 'Você precisa preencher o ' + missingFields + ' do paciente para criar um receituário digital!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          });
          return false;
        }

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        this.api.initPrescription(this.personForm.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.currentPrescription = {
            'id': res.data.id,
            'embed_url': res.data.embed_url,
            'external_id': res.data.prescription.idPrescricao
          };
          this.$bvModal.show('prescription-form-modal');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Start Prescription', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos inicializar o receituário digital. Por favor, entre em contato com o suporte!';

          if (typeof err.response != 'undefined')
            switch (err.response.status) {
              case 400:
                msg = err.response.data.message;
                break;
              case 422:
                msg = err.response.data.errors.join('\r\n');
                break;
            }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Start Prescription', err.response);
        });
      },

      processPrescriptionEvent(event) {
        const validEvents = ['cancel', 'excluded', 'prescricao'];
        if(validEvents.includes(event.data.type)) {
          this.$bvModal.hide('prescription-form-modal');
          if(event.data.type == 'prescricao' && this.currentPrescription != null) {
            this.currentPrescription.value = event.data;
            this.attendancePrescriptions.push(this.currentPrescription);
            this.currentPrescription = null;
          }
        }
      },
      buildFormSelectedAddress(unit) {
        let address = unit.display_address;
        if(address != null) {
          return address.address+', '+address.number+' - '+address.city+', '+address.state;
        }
      },

      sendTelehealthWhatsapp() {
        let message = "Link de acesso: " + this.aolUrl + "teleconsulta/" + this.telehealthAttendance.id + "\n" +
            "Código de acesso: *" + this.telehealthAttendance.code + "*";
        window.open('https://wa.me/55'+this.personForm.cellphone.replace(/\D/g, '')+'?text='+encodeURIComponent(message));
      },

      showReminderModal() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.$bvModal.show('reminder-modal');
        this.canPerformAction = true;
      },

      editReminder(reminder) {
        this.reminderForm = {
          id: reminder.id,
          date: this.moment(reminder.date).format('DD/MM/YYYY'),
          type: this.reminderTypes.find(reminderType => reminderType.value == reminder.reminder_type_id),
          description: reminder.description
        };

        this.$bvModal.show('reminder-modal');
      },

      async saveReminder() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.reminderForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let reminderData = {
          id: this.reminderForm.id,
          date: this.reminderForm.date,
          reminder_type_id: this.reminderForm.type.value,
          description: this.reminderForm.description,
        };

        this.eventBus.$emit('IS_LOADING', true);
        if(this.reminderForm.id == null) {
          await this.api.storePersonReminder(this.personForm.id, reminderData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            if (res.status == 201) {
              this.$bvModal.hide('reminder-modal');
              this.reminders.push(res.data);

              this.$swal('Uhull \\o/', 'O lembrete foi cadastrado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Person Reminder', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            let msg = 'Não conseguimos cadastrar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Person Reminder', err.response);
          });
        } else {
          await this.api.updatePersonReminder(this.personForm.id, this.reminderForm.id, reminderData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            if (res.status == 200) {
              this.$bvModal.hide('reminder-modal');

              let editedReminder = this.reminders.find(r => r.id == this.reminderForm.id),
                  index = this.reminders.indexOf(editedReminder);
              this.reminders.splice(index, 1);
              this.reminders.push(res.data);

              this.$swal('Uhull \\o/', 'O lembrete foi atualizado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Person Reminder', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            let msg = 'Não conseguimos atualizar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Person Reminder', err.response);
          });
        }
      },

      deleteReminder(reminder) {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Excluir lembrete',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deletePersonReminder(this.personForm.id, reminder.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                let deletedReminder = this.reminders.find(r => r.id == reminder.id),
                    index = this.reminders.indexOf(deletedReminder);
                this.reminders.splice(index, 1);

                this.$swal('Uhull \\o/', 'O lembrete foi excluído com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir o lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }
              this.$bvModal.hide('reminder-modal');

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Reminder', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Reminder', err.response);
            });
          }
        });
      },

      getPersonRemindersTimeline() {
        let personTimeline = [];

        this.reminders.forEach(reminder => {
          personTimeline.push(reminder.date);
        });

        personTimeline = personTimeline.sort((a, b) => this.moment(b).diff(this.moment(a)));
        personTimeline = [... new Set(personTimeline)];

        personTimeline = personTimeline.reverse();
        return personTimeline;
      },

      getRemindersByDate(date) {
        date = this.moment(date);
        return this.reminders.filter(reminder => {
          return this.moment(reminder.date).isSame(date, 'day');
        });
      },

      resetReminderModal() {
        this.reminderForm = {
          id: null,
          type: null,
          description: '',
          date: '',
        };
      },

      shorten(str, maxLen, separator = ' ', ellipsize = true) {
        if (str.length <= maxLen) return str;
        return str.substring(0, str.lastIndexOf(separator, maxLen)) + (ellipsize ? '...' : '');
      }
    },

    beforeDestroy() {
      if(this.interval != null) {
        clearInterval(this.interval);
        // localStorage.setItem('attendanceForms_' + this.$route.params.patientId, compressToUTF16(JSON.stringify(this.attendanceForms)));
        try {
          localStorage.setItem('attendanceForms_' + this.$route.params.patientId, JSON.stringify(this.attendanceForms));
        } catch (err) {
          this.sentry.captureMessage(JSON.stringify(this.attendanceForms));
          throw err;
        }
        localStorage.setItem('attendancePrescriptions_' + this.$route.params.patientId, JSON.stringify(this.attendancePrescriptions));
      }
      if(this.telehealthCheckInterval != null) {
        clearInterval(this.telehealthCheckInterval);
      }
      this.leaveChannel();
      window.removeEventListener('message', this.processPrescriptionEvent);
    },

    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      if(this.findAttendanceGuideProceduresTimer !== null) {
        clearTimeout(this.findAttendanceGuideProceduresTimer);
      }
      next();
    }
  }
</script>

<style lang="scss">
  .telehealth {
    display: flex;
    overflow: hidden;
    min-height: 100vh;

    .telehealth-content {
      flex: 1;
      background-color: #f0f2f8;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
    }
  }

  @media (max-width: 767px) {
    .telehealth {
      flex-flow: column wrap;
    }

    //.telehealth-content {
    //  margin-top: 86px;
    //  height: calc(100vh - 86px) !important;
    //}
  }

  @media print {
    .content {
      background-color: #ffffff !important;
      height: auto !important;
    }
  }


  .telehealth-form {
    padding: 14px 0;

    .appointments-list {
      padding-left: 9px;

      li {
        padding: 2px 20px 15px 20px;
        position: relative;
        transition: all 0.5s;

        &:after {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #FFFFFF;
          border: 2px solid $linkWater;
          content: ' ';
          position: absolute;
          top: 10px;
          left: -4px;
          transition: all 0.5s;
        }

        .timeline {
          position: absolute;
          width: 2px;
          height: 100%;
          background-color: $linkWater;
          left: -1px;
          top: 10px;
        }

        &.current-day {
          &:after {
            border-color: $pictionBlue;
          }

          &:before {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background-color: $columbiaBlue;
            content: ' ';
            position: absolute;
            top: 7px;
            left: -7px;
            transition: all 0.5s;
          }
        }

        &:last-child {
          .timeline {
            display: none;
          }
        }
      }

      p {
        font-family: 'sf_pro_displaymedium';
        margin: 0;
      }

      .attendance-item {
        color: $pictionBlue;
        width: 100%;
        cursor: pointer;
        font-size: 15px;
      }

      .reminder-item {
        color: $pictionBlue;
        width: 100%;
        cursor: pointer;
        font-size: 14px;
      }

      .info {
        font-weight: 500;
        color: $waikawaGray;

        .row {
          padding-bottom: 5px;
          margin-bottom: 10px;
          border-bottom: 1px solid $linkWater;
        }
      }

      .date {
        color: $cadetGray;
        font-size: 15px;
      }
    }

    .time {
      font-size: 36px;
      line-height: 36px;
      color: $linkWater;
      font-family: 'sf_pro_displaymedium';
    }

    .preview {
      color: $waikawaGray;
      font-size: 14px;

      &.name {
        font-size: 18px;
        color: $bunting;
      }
    }

    .show-full {
      font-size: 12px;
      color: $cadetGray;
      cursor: pointer;
    }

    .printable {
      display: none;
    }

    @media print {
      & > .container, .box-fullcalendar {
        display: none !important;
      }

      .printable {
        display: block !important;
        padding: 20px;

        .print-header {
          padding: 0 18px 15px;
          width: 100%;

          img {
            position: relative;
            display: inline-block;
            vertical-align: baseline;
            margin-right: 24px;
          }
          .print-client-info {
            width: calc(50% - 62px);
            position: relative;
            display: inline-block;
            font-size: 14px;

            h1 {
              font-size: 20px;
            }
          }
        }

        .fields {
          position: relative;

          .field {
            position: relative;
            display: inline-block;
            margin: 10px 15px;
            border: 1px solid #000000;
            border-radius: 0;
            background-color: #ffffff;
            padding: 15px 15px;
            page-break-after: auto;
            page-break-inside: avoid;

            &.field-3 { width: calc(25% - 30px); }
            &.field-4 { width: calc(33% - 30px); }
            &.field-6 { width: calc(50% - 30px); }
            &.field-9 { width: calc(75% - 30px); }
            &.field-12 { width: calc(100% - 30px); }

            label {
              position: absolute;
              top: -12px;
              left: 15px;
              background-color: #ffffff;
              padding: 3px 5px;
              color: #000000;
            }

            textarea {
              resize: none;
            }

            .form-control {
              border: none;
              background-color: transparent;
              padding: 0;
            }
          }
        }
      }
    }
  }

  .patient-status-text {
    font-size: 18px;
  }

  .agora-uikit-cj {
    width: 100%;
    height: calc(100vh - 24px);
    display: flex;

    .agora-call {
      min-height: 0px;
      display: flex;
      flex: 1 1 0;
      flex-direction: column;

      #participants {
        width: 100%;
        height: 100%;
        display: grid;
      }
    }
  }

  .header {
    &.appointment-history-header {
      padding: 15px 20px 0 12px!important;

      .nav-tabs {
        margin-bottom: -1px;
        border-bottom: 1px solid $athenGray2;

        .show-appointments {
          font-size: 15px;
          color: $cadetGray;
          padding: 0.5rem 0.7rem;

          &.active {
            border-color: $athenGray2 $athenGray2 #fff;
            color: $bunting;
          }
          &:hover {
            border-color: #e9ecef #e9ecef $athenGray2;
            color: $bunting;
          }
        }
      }
    }
  }

  .tab-content .box-cj {
    background: $whisper!important;

    .header, .content {
      padding: 8px 12px!important;

      .table {
        margin-bottom: 0;

        tbody td {
          font-size: 14px;
          font-family: 'sf_pro_displayregular';
        }
      }
    }
  }

  .notes-container {
    border-left: 1px solid $cadetGray;

    .note-value {
      color: $waikawaGray;
      font-size: 14px;
    }

    @media only screen and (max-width : 767px) {
      border-left: 0;
      border-top: 1px solid $cadetGray;
      padding-top: 10px;
      margin-top: 10px;
    }
  }

  #prescription-form-modal {
    .modal-dialog {
      margin: 15px auto;

      .modal-body {
        padding: 0;

        iframe {
          width: 100%;
          height: calc(100vh - 40px);
        }
      }
    }

    @media only screen and (max-width : 576px) {
      padding-left: 5px!important;
      padding-right: 5px!important;

      &___BV_modal_outer_ {
        z-index: 1000000000!important;
      }

      .modal-dialog {
        margin: 10px auto;

        .modal-body iframe {
          height: calc(100vh - 30px);
        }
      }
    }
  }

  .text1 {
    font-size: 15px;
    color: $cadetGray;
    margin-bottom: 0;
  }
</style>
